import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import { styled } from "@mui/material/styles";
import { Alert, Box, LinearProgress, Skeleton, Stack } from "@mui/material";
import { fetchRSLevelFiboData, fetchrslFibo } from "../../../../Utilities/Url";
import { utils, writeFile } from "xlsx";
import DownloadIcon from "@mui/icons-material/Download";
import { canExportToCSV } from "../config";

const RsFiboTable = () => {
  const searchItem = useSelector((state) => state.SearchItems);
  const SetError = useSelector((state) => state.SetError);
  const authToken = useSelector((state) => state.authToken);
  const selectedAnalytics = useSelector((state) => state.selectedAnalytics);

  const RSLevelFibo = useSelector((state) => state.RsFibo);
  const TableTickerName = useSelector((state) => state.TickerName);
  const rowsPerPage = useSelector((state) => state.RowsPerPage);
  const page = useSelector((state) => state.SetPage);
  const selectedExchange = useSelector((state) => state.SetExchange);
  const setActiveButton = useSelector((state) => state.ActiveButton);
  const SelectedDropdownOption = useSelector(
    (state) => state.SelectedDropdownOption
  );
  const isLoading = useSelector((state) => state.isLoading);

  // const [RSLevelFibo,setRSLevelFibo] = useState([])
  useEffect(() => {
    fetchrslFibo(
      selectedExchange,
      setActiveButton,
      SelectedDropdownOption,
      dispatch,
      authToken,
      selectedAnalytics
    );
  }, [setActiveButton, selectedExchange, SelectedDropdownOption]);
  const dispatch = useDispatch();
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#ebebeb",
      color: theme.palette.common.black,
      borderRight: `1px solid ${theme.palette.divider}`,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
      borderRight: `1px solid ${theme.palette.divider}`,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      // backgroundColor: theme.palette.action.hover,
    },
    "&:last-child td, &:last-child th": {
      border: 0,
      borderRight: `1px solid ${theme.palette.divider}`,
    },
    fontWeight: "normal",
  }));

  const rowsPerPageOptions = [5, 10, 25];

  const handleChangePage = (event, newPage) => {
    dispatch({ type: "SET_PAGE", payload: newPage });
  };

  const handleChangeRowsPerPage = (event) => {
    dispatch({
      type: "ROWS_PER_PAGE",
      payload: parseInt(event.target.value, 10),
    });
    dispatch({ type: "SET_PAGE", payload: 0 });
  };
  const handleFirstPageButtonClick = (event) => {
    handleChangePage(event, 0);
  };

  const handleLastPageButtonClick = (event, count) => {
    handleChangePage(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  const TablePaginationActions = (props) => {
    const { count, page, rowsPerPage, onPageChange } = props;

    return (
      <div style={{ flexShrink: 0, marginLeft: "2.5em" }}>
        <IconButton
          onClick={(event) => onPageChange(event, 0)}
          disabled={page === 0}
          aria-label="first page"
        >
          <FirstPageIcon />
        </IconButton>
        <IconButton
          onClick={(event) => onPageChange(event, page - 1)}
          disabled={page === 0}
          aria-label="previous page"
        >
          <KeyboardArrowLeft />
        </IconButton>
        <IconButton
          onClick={(event) => onPageChange(event, page + 1)}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          <KeyboardArrowRight />
        </IconButton>
        <IconButton
          onClick={(event) => handleLastPageButtonClick(event, count)}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="last page"
        >
          <LastPageIcon />
        </IconButton>
      </div>
    );
  };

  let filterTicker = RSLevelFibo.filter((ele) =>
    ele.Ticker.includes(searchItem[searchItem.length - 1])
  );
  const handleExportCSV = () => {
    const headers = [
      "Ticker",
      "SUP-LVL-3",
      "SUP-LVL-2",
      "SUP-LVL-1",
      "PP",
      "R&S-LVL-1",
      "R&S-LVL-2",
      "R&S-LVL-3",
    ];

    const csvData = RSLevelFibo.map((item, index) => {
      return [
        item.Ticker || "",
        item.SupportLevel3?.toFixed(2),
        item.SupportLevel2?.toFixed(2),
        item.SupportLevel1?.toFixed(2),
        item.Pp?.toFixed(2),
        item.ResistanceLevel1?.toFixed(2),
        item.ResistanceLevel2?.toFixed(2),
        item.ResistanceLevel3?.toFixed(2),
      ];
    });
    const data = [headers, ...csvData];
    const ws = utils.aoa_to_sheet(data);

    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "RsFibonacciData");

    writeFile(wb, "RsFibonacciData.xlsx");
  };

  return (
    <div>
      {isLoading ? (
        <Stack spacing={1} padding={"5px"}>
          <Skeleton
            variant="rectangular"
            width="100%"
            height={200}
            animation="wave"
          />
          <Skeleton
            variant="rectangular"
            width="100%"
            height={50}
            animation="wave"
          />
          <div style={{ display: "flex", flexDirection: "row", gap: "15px" }}>
            <Skeleton
              variant="rectangular"
              width={300}
              height={100}
              animation="wave"
            />
            <Skeleton
              variant="rectangular"
              width={300}
              height={100}
              animation="wave"
            />
          </div>
        </Stack>
      ) : (
        <TableContainer sx={{ maxHeight: 390 }}>
          {canExportToCSV && (
            <div
              style={{
                display: "flex",
                justifyContent: "end",
                padding: "6px",
                cursor: "pointer",
              }}
            >
              <DownloadIcon
                onClick={handleExportCSV}
                aria-label="export to CSV"
              />
            </div>
          )}
          <Table stickyHeader aria-label="customized table" size="small">
            <TableHead>
              <TableRow>
                <StyledTableCell
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                >
                  Ticker
                </StyledTableCell>
                <StyledTableCell
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                >
                  Sup Lvl 3
                </StyledTableCell>
                <StyledTableCell
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                >
                  Sup Lvl 2
                </StyledTableCell>
                <StyledTableCell
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                >
                  Sup Lvl 1
                </StyledTableCell>
                <StyledTableCell
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                >
                  PP
                </StyledTableCell>
                <StyledTableCell
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                >
                  R&S Lvl 1
                </StyledTableCell>
                <StyledTableCell
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                >
                  R&S Lvl 2
                </StyledTableCell>
                <StyledTableCell
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                >
                  R&S Lvl 3
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {searchItem.length !== 0 && filterTicker.length === 0 ? (
                <TableRow>
                  <StyledTableCell colSpan={10} align="center">
                    NO DATA FOUND
                  </StyledTableCell>
                </TableRow>
              ) : (
                (filterTicker.length === 0 ? RSLevelFibo : filterTicker)
                  ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((item, index) => (
                    <StyledTableRow key={index}>
                      <StyledTableCell>{item.Ticker}</StyledTableCell>
                      <StyledTableCell sx={{ textAlign: "right" }}>
                        {item.SupportLevel3?.toFixed(2)}
                      </StyledTableCell>
                      <StyledTableCell sx={{ textAlign: "right" }}>
                        {item.SupportLevel2?.toFixed(2)}
                      </StyledTableCell>
                      <StyledTableCell sx={{ textAlign: "right" }}>
                        {item.SupportLevel1?.toFixed(2)}
                      </StyledTableCell>
                      <StyledTableCell sx={{ textAlign: "right" }}>
                        {item.Pp?.toFixed(2)}
                      </StyledTableCell>

                      <StyledTableCell sx={{ textAlign: "right" }}>
                        {item.ResistanceLevel1?.toFixed(2)}
                      </StyledTableCell>
                      <StyledTableCell sx={{ textAlign: "right" }}>
                        {item.ResistanceLevel2?.toFixed(2)}
                      </StyledTableCell>
                      <StyledTableCell sx={{ textAlign: "right" }}>
                        {item.ResistanceLevel3?.toFixed(2)}
                      </StyledTableCell>
                    </StyledTableRow>
                  ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      {!(searchItem.length !== 0 && filterTicker.length === 0) &&
        !isLoading && (
          <TablePagination
            rowsPerPageOptions={rowsPerPageOptions}
            component="div"
            count={
              filterTicker.length === 0
                ? RSLevelFibo.length
                : filterTicker.length || 0
            }
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            ActionsComponent={TablePaginationActions}
          />
        )}
    </div>
  );
};

export default RsFiboTable;
